export var LatLongDirection;
(function (LatLongDirection) {
    LatLongDirection["NORTH"] = "N";
    LatLongDirection["SOUTH"] = "S";
    LatLongDirection["EAST"] = "E";
    LatLongDirection["WEST"] = "W";
})(LatLongDirection || (LatLongDirection = {}));
//# sourceMappingURL=Directions.js.map